import React from 'react';
export const Header = () =>
{
    return(<h1 id = "cb_header">Cyberbox Test</h1>);
} 